import { FC } from "react";

import { Button } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { trackEngagement } from "helpers/analytics";

interface IProps {
  onClick: () => void;
}

export const ManageAgentsButton: FC<IProps> = ({ onClick }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = () => {
    trackEngagement("Teams: Manage agents modal opened");
    onClick();
  };

  return (
    <Block>
      <Button kind="secondary" size="compact" onClick={handleClick} data-testid="manage-agents-button">
        Manage agents
      </Button>
    </Block>
  );
};
